import { defineMessages } from 'react-intl';

export default defineMessages({
  enableHeader: {
    id: 'frontbucket.search.beta.enableHeader',
    description: 'Notice that search is not enabled for the selected account',
    defaultMessage: 'Search through all your code',
  },
  enableDescription: {
    id: 'frontbucket.search.beta.enableDescription',
    description: 'Information about enabling search for the selected account',
    defaultMessage: `Enable search and we’ll get to work indexing all your code. Go grab a coffee, and you’ll be able to search on your return.`,
  },
  enable: {
    id: 'frontbucket.search.beta.enable',
    description: 'Link to opt into the search beta',
    defaultMessage: 'Enable code search',
  },
});
